import { TextareaAutosize } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { StyledClientsEditNickname } from "../../../clients/styledClients";
import { StyledEventLogs } from "../../../logs/styledLogs";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const ExclusionValueUpdateForm = ({ exclusion, t, notification, setNotification, setFetch }) => {
  const [currentValue, setCurrentValue] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth
  });

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth
    });
  };

  const refHeight = useRef(null);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    setIsOverflow(refHeight.current.clientHeight >= 70);
  }, [windowSize.width]);

  const save = () => {
    if (!currentValue || currentValue === exclusion?.exclusionValuesString) {
      setIsEdit(false);
      setCurrentValue(exclusion.exclusionValuesString);
      return;
    }

    handleUpdate();
  };

  const cancel = () => {
    setIsEdit(false);
    setCurrentValue(exclusion?.exclusionValuesString);
  };

  const handleUpdate = () => {
    let data = {
      exclusionValuesString: currentValue
    };

    axios.put(`/api/service-exclusion-lists/${exclusion.id}`, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setIsEdit(false);
        setCurrentValue(response.data.exclusionValuesString);
        setNotification({ ...notification, visible: true, type: "success", message: t("exclusions.successEdit") });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    setCurrentValue(exclusion?.exclusionValuesString);
  }, [exclusion]);

  return (
    <StyledClientsEditNickname>
      {isEdit ? (
        <div className="nickname-edit-form">
          <TextareaAutosize
            id={`value.${exclusion.id}`}
            value={currentValue ?? exclusion?.exclusionValuesString}
            onChange={(event) => setCurrentValue(event.target.value)}
          />
          <div className="nickname-edit-form__actions">
            <button
              className="table-action"
              onClick={save}
            >
              <span className="icon-light-check" />
              {t("exclusions.editForm.save")}
            </button>
            <button
              className="table-action table-action_danger"
              onClick={cancel}
            >
              <span className="icon-light-cancel" />
              {t("exclusions.editForm.cancel")}
            </button>
          </div>
        </div>
      ) : (
        <div className="nickname-edit">
          {/* TODO copied from logs, need refactoring */}
          <StyledEventLogs ref={refHeight} show={show}>
            <StyledBreakWord as="p">
              {currentValue ?? exclusion?.exclusionValuesString}
            </StyledBreakWord>
          </StyledEventLogs>
          <button className={`read-more ${isOverflow && "read-more_is-overflow"} ${show && "read-more_active"}`}
                  onClick={() => setShow(!show)}>
            {show ? t("exclusions.table.hide") : t("exclusions.table.detail")}
          </button>
          <button
            className="table-action table-action_info"
            onClick={() => setIsEdit(true)}
          >
            <span className="icon-light-edit" />
            {t("exclusions.editForm.edit")}
          </button>
        </div>
      )}
    </StyledClientsEditNickname>
  );
};

export default ExclusionValueUpdateForm;